import * as React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Box, Card, CardContent, Typography } from '@mui/material';

import Button from '../../../components/Button/Button';
import SvgIcon from '../../../components/Icons';

const AddProduct: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Card
      onClick={() => navigate('/products/create')}
      sx={{
        minHeight: '390px',
        maxHeight: '390px',
        maxWidth: 345,
        height: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        border: '1px dashed #eee',
        background: 'transparent',
        boxShadow: '0px 0px 20px 0px #0000000F',
        fontFamily: 'Poppins',
        cursor: 'pointer',
        borderRadius: '12px',
        transition: 'box-shadow 150ms ease, transform 150ms ease',
        '&:hover': {
          boxShadow: '0px 4px 24px 0px #00000014',
        },
      }}
    >
      <CardContent
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          pb: '72px',
        }}
      >
        <Box display='flex'>
          <SvgIcon name='NewOffer' inheritViewBox sx={{ fontSize: 100 }} />
        </Box>
        <Typography color={'#232832'} fontSize={'18px'} fontWeight={500} textAlign={'center'}>
          Start promoting your brand
        </Typography>
        <Typography color='#707070' fontSize={'13px'} textAlign={'center'}>
          Get posts and content in exchange for your producs
        </Typography>
      </CardContent>
      <Box sx={{ position: 'absolute', left: 14, right: 14, bottom: 13 }}>
        <Button
          component={Link}
          to='/products/create'
          variant='contained'
          size='large'
          fullWidth
          sx={{ borderRadius: '8px' }}
        >
          List your first product
        </Button>
      </Box>
    </Card>
  );
};

export default AddProduct;
